import React from "react";
import {Button, Input, Modal, Form, Switch} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
}

export default function ExpressEditModal(props: ModifyModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                <Form.Item label={'快递名称'} name={'name'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'描述'} name={'desc'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'冷链'} name={'coldChain'} initialValue={false} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
            </Form>
        </Modal>
    )
}
